import { useEffect } from "react";
import * as Sentry from "@sentry/react";
import { useAuth } from "@/contexts/AuthContext";
import { useRestaurantStore } from "@/stores/restaurantStore";

/**
 * Syncs Supabase user id and active restaurant to Sentry scope (no email / PII).
 */
export function SentryUserContext() {
  const { user } = useAuth();

  useEffect(() => {
    if (user?.id) {
      Sentry.setUser({ id: user.id });
    } else {
      Sentry.setUser(null);
    }
  }, [user?.id]);

  useEffect(() => {
    const syncRestaurant = (id: string | null) => {
      Sentry.setTag("restaurant_id", id ?? "none");
    };

    syncRestaurant(useRestaurantStore.getState().activeRestaurantId);
    return useRestaurantStore.subscribe((state) => {
      syncRestaurant(state.activeRestaurantId);
    });
  }, []);

  return null;
}
